
export const CALL_TYPES = [
  { value: "overdue", label: "Overdue" },
  { value: "negotiation", label: "Negotiation" },
];
